import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-teal-600 shadow-2xl z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <i className="ri-cookie-line text-2xl text-teal-600 mt-1"></i>
            <div>
              <h3 className="text-base font-semibold text-gray-900 mb-1">
                Uso de Cookies
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación, 
                analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en "Aceptar", 
                consientes el uso de todas las cookies.
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-3 whitespace-nowrap">
            <button
              onClick={handleReject}
              className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
            >
              Rechazar
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2.5 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition-colors cursor-pointer shadow-md"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
